/*================================ COMMONS ==============================*/
import CONFIG from "config/config";
import { CSSProperties } from "react";
import {
  generatePrefixedActions,
  BLC_STATUS,
  OptionType,
  BLC_STATUS_TYPE,
} from "../../../../../src/react-lib/apps/HISV3/common/CommonInterface";

/*================================ APIS ==============================*/
import DiagRuleList from "issara-sdk/apis/DiagRuleList_apps_PRX";
import DiagRuleDetail from "issara-sdk/apis/DiagRuleDetail_apps_PRX";
import PublishedDiagRuleList from "issara-sdk/apis/PublishedDiagRuleList_apps_PRX";
import PublishedDiagRuleNodeDetail from "issara-sdk/apis/PublishedDiagRuleNodeDetail_apps_PRX";
import PublishedDiagRuleNodeList from "issara-sdk/apis/PublishedDiagRuleNodeList_apps_PRX";
import PublishedDiagRuleNodeFromNodeIdView from "issara-sdk/apis/PublishedDiagRuleNodeFromNodeIdView_apps_PRX";
import BroadcastPostList from "issara-sdk/apis/BroadcastPostListCreateView_apps_PRX";
import BroadcastPostCalculateCredit from "issara-sdk/apis/BroadcastPostCalculateCreditView_apps_PRX";
import FindPatientByLeafNode from "issara-sdk/apis/FindPatientsByLeafNodeAPI_apps_PRX";
import UserEmployeeDetailAPIView from "issara-sdk/apis/UserEmployeeDetailAPIView_users";
import FormCategoryList from "issara-sdk/apis/FormCategoryList_apps_PRX";
import DiagRuleDownloadDiagFormAnswerXLSXView from "issara-sdk/apis/DiagRuleDownloadDiagFormAnswerXLSXView_apps_PRX";

/*================================ SERIALIZERS ==============================*/
import DiagRuleSerializer from "issara-sdk/types/DiagRuleSerializer_apps_PRX";
import PublishedDiagRuleSerializer from "issara-sdk/types/PublishedDiagRuleSerializer_apps_PRX";
import PublishedDiagRuleNodeSerializer from "issara-sdk/types/PublishedDiagRuleNodeSerializer_apps_PRX";
import BroadcastPostSerializer from "issara-sdk/types/BroadcastPostSerializer_apps_PRX";
import EmployeeSerializer from "issara-sdk/types/EmployeeSerializer_users";
import FormCategorySerializer from "@/issara-sdk/types/FormCategorySerializer_apps_PRX";

/*================================ TYPES ==============================*/
import {
  ACTIONS,
  SEQUENCE_NAME,
  MAIN_CARD_NAME,
  LIST_CARD_NAME,
  DETAIL_CARD_NAME,
  State,
  CreatedData,
  SaveFormData,
  Data,
  Actions,
  SeqState,
  ActionType,
  Params,
  Handler,
  Controller,
  MeFormDetailPage,
  BroadcastStatus,
  PostCalculateCreditParams,
  PostCalculateCredit,
  BROADCAST_LIST_SEGMENT_NAME,
  DEFAULT_BROADCAST_LIST_LIMIT,
  BroadcastNodeParams,
  CreatedBroadcastData,
  CreatedBroadcastDataApi,
  BROADCAST_CARD_NAME,
  BroadcastListType,
  BroadcastDataFirebase,
  COLLECTION,
  MEHEALTH_BROADCAST_GS,
  PatientByLeafResponse,
  DiagFormListResponse,
  FormCategoryParams,
  setLoading,
  setButtonLoadCheck,
  setErrorMessage,
  setSuccessMessage,
  UpdatedUserFirebase
} from "../MeFormType";
import { addDoc, collection, doc, DocumentData, Firestore, getDoc, getDocs, QuerySnapshot, setDoc, Timestamp } from "firebase/firestore";
import { FirebaseStorage, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

import { downloadXLSX } from "react-lib/apps/HISV3/common/CommonInterface";

/*================================ CONSTANTS ==============================*/

export const StateInitial: State = {
  MeFormSequence: null,
};

export const DataInitial: Data = {};

const Masters = [] as const;

export const BTN_ACTS = generatePrefixedActions(ACTIONS, SEQUENCE_NAME);

export const INIT_NODE: string = JSON.stringify({
  // Root
  0: {
    id: 0,
    parent_id: null,
    level: 0,
    span: 1,
    label: "",
    group_name: "",
    text: "",
    condition: "first",
    type: "choices",
  },
  // Child
  1: {
    id: 1,
    parent_id: 0,
    level: 1,
    span: 0,
    label: "",
    group_name: "",
    text: "",
    condition: "",
    type: "end",
  },
});

export const STYLES: Record<string, CSSProperties> = {
  primaryThemeBasicBtn: {
    backgroundColor: "white",
    border: "solid 1px var(--primary-theme-color)",
    borderRadius: "5px",
  },
  primaryThemeBtn: {
    backgroundColor: "var(--primary-theme-color)",
    color: "white",
    borderRadius: "5px",
  },
  primaryThemeLabel: {
    backgroundColor: "var(--primary-select-background)",
    color: "black",
    borderRadius: "5px",
  },
  published: {
    backgroundColor: "var(--primary-theme-color)",
  },
  unpublished: {
    backgroundColor: "lightgrey",
  },
};

export const ICONS: Record<string, string> = {
  question: "static/images/meform/question.png",
  folder: "static/images/meform/folder.png",
  addNew: "static/images/meform/add-new.png",
  addQuestion: "static/images/meform/add-question.png",
  edit: "static/images/meform/edit.png",
  remove: "static/images/meform/remove.png",
  collapse: "static/images/meform/collapse-folder.png",
  expand: "static/images/meform/expand-folder.png",
  duplicate: "static/images/meform/duplicate.png",
  copyLink: "static/images/meform/copy-link.png",
  publish: "static/images/meform/publish.png",
  testRun: "static/images/meform/test-run.png",
  broadcast: "static/images/meform/broadcast.png",
  bullhorn: "static/images/meform/bullhorn.png",
  member: "static/images/meform/member.png",
  saveDraft: "static/images/meform/save-draft.png",
  inPreview: "static/images/meform/in-preview.png",
  goBack: "static/images/meform/go-back.png",
};

export const AllOption = { key: "ALL", value: "ALL", text: "ALL" };

export const FORM_TYPE_OPTIONS: OptionType[] = [
  // { key: "INPUT_FORM", value: "INPUT_FORM", text: "Input Form" },
  { key: "DECISION_TREE", value: "DECISION_TREE", text: "Decision Tree (แบบฟอร์มเลือกเส้นทาง)" },
];

export const DEFAULT_DIAG_FORM_LIMIT = 10;

// const FIREBASE_PATH: string = `mehealth_broadcast` as const;

/*================================ START SEQUENCE ==============================*/

export const Start: Handler<SeqState> = async (controller, params) => {
  controller.handleEvent({
    message: "GetMasterData",
    params: { masters: Masters },
  });

  // Init Data
  setLoading(controller, LIST_CARD_NAME, true);

  const currentDivision = controller?.data?.division;

  const [formCategoryList, activeListResp, inactiveListResp] = await Promise.all([
    getFormCategoryList(controller, { formCategoryParams: { division: currentDivision } }),
    getDiagRuleList(controller, { division: currentDivision, active: true }),
    getDiagRuleList(controller, { division: currentDivision, active: false }),
  ]);

  setLoading(controller, LIST_CARD_NAME, false);

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      sequenceIndex: "Action",
      common: {
        ...prev.MeFormSequence?.common,
        formCategoryList
      },
      formListPage: {
        ...prev.MeFormSequence?.formListPage,
        activeList: {
          ...prev.MeFormSequence?.formListPage?.activeList,
          items: activeListResp?.items || [],
          total: activeListResp?.total || 0,
        },
        inactiveList: {
          ...prev.MeFormSequence?.formListPage?.inactiveList,
          items: inactiveListResp?.items || [],
          total: inactiveListResp?.total || 0,
        },
      },
    },
  }));
};

/*================================ ACTIONS ==============================*/

export const Action: Handler<ActionType> = async (controller, params) => {
  const actionHandlers: Partial<{ [K in ActionType["action"]]: Handler<Params<K>> }> = {
    [ACTIONS.FETCH]: HandleFetch,
    [ACTIONS.ADD_FORM]: HandleAddForm,
    [ACTIONS.GET_FORM]: HandleGetForm,
    [ACTIONS.ACTION_FORM]: HandleActionForm,
    [ACTIONS.DOWNLOAD_RAW]: HandleDownloadRaw,
    [ACTIONS.SAVE_FORM]: HandleSaveForm,
    [ACTIONS.PUBLISH_FORM]: HandlePublishForm,
    [ACTIONS.EDIT_FORM]: HandleEditForm,
    [ACTIONS.GET_BROADCAST_NODE_LIST]: HandleGetBroadcastNodeList,
    [ACTIONS.GET_POST_CALCULATE_CREDIT]: HandleGetPostCalculateCredit,
    [ACTIONS.POST_BROADCAST]: HandleCreatePostBroadcast,
    [ACTIONS.GET_UPDATED_BY_USER_FIREBASE]: GetUpdatedByUserFirebase,
    [ACTIONS.ADD_CONTENT]: HandleAddContent,
    [ACTIONS.UPDATE_CONTENT]: HandleUpdateContent,
  };

  const action = params.action;

  const handler = actionHandlers[action] as Handler<Params<typeof action>> | undefined;

  if (handler) {
    if (action === "UPDATE_CONTENT") {
      return handler(controller, params);
    } else {
      handler(controller, params);
    }
  } else {
    console.error(`The handler not found for action: ${action}`);
  }
};

const HandleFetch: Handler<Params<Actions["FETCH"]>> = async (controller, params) => {
  setLoading(controller, LIST_CARD_NAME, true);

  const division = params.division ?? controller.data?.division;

  const activePage = params.activePage || 1;
  const inactivePage = params.inactivePage || 1;

  const activeOffset = (activePage - 1) * DEFAULT_DIAG_FORM_LIMIT;
  const inactiveOffset = (inactivePage - 1) * DEFAULT_DIAG_FORM_LIMIT;

  const [activeListResp, inactiveListResp] = await Promise.all([
    getDiagRuleList(controller, { division, active: true, offset: activeOffset }),
    getDiagRuleList(controller, { division, active: false, offset: inactiveOffset }),
  ]);

  setLoading(controller, LIST_CARD_NAME, false);

  controller.setState((prev) => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      formListPage: {
        ...prev.MeFormSequence?.formListPage,
        activeList: {
          ...prev.MeFormSequence?.formListPage?.activeList,
          activePage,
          items: activeListResp?.items || [],
          total: activeListResp?.total || 0,
        },
        inactiveList: {
          ...prev.MeFormSequence?.formListPage?.inactiveList,
          activePage: inactivePage,
          items: inactiveListResp?.items || [],
          total: inactiveListResp?.total || 0,
        },
      },
      // clear detail
      ...(params.detailData
        ? {
            formDetailPage: {
              ...prev.MeFormSequence?.formDetailPage,
              formId: params.detailData.id,
              formDetail: params.detailData,
              ...(params.pdrNodeData ? { pdrNodeList: params.pdrNodeData } : {}),
            },
          }
        : {
            formDetailPage: undefined,
          }),
    },
  }));
};

const HandleGetForm: Handler<Params<Actions["GET_FORM"]>> = async (controller, params) => {
  const { formId } = params;

  // --- Update Form Detail Func
  const updateFormDetailPage = (partial: MeFormDetailPage) => {
    setLoading(controller, DETAIL_CARD_NAME, false);
    setButtonLoadCheck(controller, BTN_ACTS.GET_FORM, BLC_STATUS.SUCCESS);

    controller.setState(prev => ({
      MeFormSequence: {
        ...prev.MeFormSequence,
        formDetailPage: {
          ...prev.MeFormSequence?.formDetailPage,
          ...partial,
        },
      },
    }));
  };

  setLoading(controller, DETAIL_CARD_NAME, true);
  setButtonLoadCheck(controller, BTN_ACTS.GET_FORM, BLC_STATUS.LOADING);

  const formResult = await getDiagRuleDetail(controller, { formId });

  if (!formResult) {
    setLoading(controller, DETAIL_CARD_NAME, false);
    setButtonLoadCheck(controller, BTN_ACTS.GET_FORM, BLC_STATUS.ERROR);

    controller.setState(prev => ({
      MeFormSequence: {
        ...prev.MeFormSequence,
        formDetailPage: undefined,
      },
    }));

    return;
  }

  // --- Form ที่เลือกยังไม่ Published ไม่ต้องเรียก PublishedDiagRuleNode
  if (!formResult.published) {
    updateFormDetailPage({
      formId: formResult.id,
      formDetail: formResult,
    });

    return;
  }

  const publishedId = formResult.latest_published_diag_rule;
  let pdrNodeList = undefined;
  let patientByLeafList = undefined;

  if (publishedId) {
    pdrNodeList = await getPublishedDiagRuleNode(controller, { publishedDiagRuleId: publishedId });

    if (pdrNodeList && pdrNodeList.length > 0) {
      const results = await Promise.all(
        pdrNodeList.map(async (node) => {
          const [resp, err] = await getPatientByLeafNode(controller, {
            findPatientParams: {
              published_diag_rule_id: publishedId,
              leaf_node_id: node.node_id,
            },
          });

          return {
            id: node.id,
            resp,
            err
          };
        })
      );

      patientByLeafList = results.reduce((acc: any, item) => {
        acc[item.id || 0] = item.err ? null : item.resp;

        return acc;
      }, {});
    }
  }

  updateFormDetailPage({
    formId: formResult.id,
    formDetail: formResult,
    ...(pdrNodeList && { pdrNodeList }),
    ...(patientByLeafList && { patientByLeafList }),
  });
};

const HandleAddForm: Handler<Params<Actions["ADD_FORM"]>> = async (controller, params) => {
  const { createdData } = params;
  const division = params.division ?? controller.data?.division;

  setButtonLoadCheck(controller, BTN_ACTS.ADD_FORM, BLC_STATUS.LOADING);

  const [createdResult, createdErr] = await createDiagRule(controller, { createdData, division });

  if (!createdResult) {
    setButtonLoadCheck(controller, BTN_ACTS.ADD_FORM, BLC_STATUS.ERROR);
    setErrorMessage(controller, MAIN_CARD_NAME, createdErr);
    return;
  }

  // fetch form category
  const formCategoryList = await getFormCategoryList(controller, { formCategoryParams: { division }});

  setButtonLoadCheck(controller, BTN_ACTS.ADD_FORM, BLC_STATUS.SUCCESS);

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      common: {
        ...prev.MeFormSequence?.common,
        formCategoryList,
      },
      formDetailPage: {
        ...prev.MeFormSequence?.formDetailPage,
        formId: createdResult.id,
        formDetail: createdResult,
        pdrNodeList: undefined,
      },
    },
  }));

  if (params.onSuccess) {
    params.onSuccess();
  }
};

const HandleActionForm: Handler<Params<Actions["ACTION_FORM"]>> = async (controller, params) => {
  const { formId, data, division } = params;
  const btnFormatted = `${BTN_ACTS.ACTION_FORM}_${formId}`;

  setButtonLoadCheck(controller, btnFormatted, BLC_STATUS.LOADING);

  const actionFormResult = await saveDiagRuleDetail(controller, { formId, data });

  if (!actionFormResult) {
    setButtonLoadCheck(controller, btnFormatted, BLC_STATUS.ERROR);
    return;
  }

  setButtonLoadCheck(controller, btnFormatted, null);

  Action(controller, {
    sequence: "MeForm",
    action: ACTIONS.FETCH,
    division: division ?? controller.data.division,
  });
};

const HandleDownloadRaw: Handler<Params<Actions["DOWNLOAD_RAW"]>> = async (controller, params) => {
  const { formId } = params;

  await downloadDiagFormAnswer(controller, { formId });
};

/*================================ FORM DETAIL ==============================*/

const HandleSaveForm: Handler<Params<Actions["SAVE_FORM"]>> = async (controller, params) => {
  const state = controller.getState();

  const { formId, data, division } = params;
  const pdrList = state.MeFormSequence?.formDetailPage?.pdrNodeList || [];
  const formDetail = state.MeFormSequence?.formDetailPage?.formDetail;

  const isSameForm = formId === state.MeFormSequence?.formDetailPage?.formId;
  const isPublished = Boolean(state.MeFormSequence?.formDetailPage?.formDetail?.published);
  const publishedId = formDetail?.latest_published_diag_rule;

  setButtonLoadCheck(controller, BTN_ACTS.SAVE_FORM, BLC_STATUS.LOADING);

  const saveFormResult = await saveDiagRuleDetail(controller, { formId, data });

  if (!saveFormResult) {
    setButtonLoadCheck(controller, BTN_ACTS.SAVE_FORM, BLC_STATUS.ERROR);
    return;
  }

  // --- Published Save Condition
  if (isSameForm && isPublished && publishedId) {
    try {
      const contentObj = JSON.parse(data.content || "{}");

      const newGroupMap: Record<number, string> = {};

      for (const key in contentObj) {
        const node = contentObj[key];

        if (node && node.id != null) {
          newGroupMap[node.id] = node.group_name;
        }
      }

      const changedNodes = pdrList.filter((pdr) => {
        const newGroup = newGroupMap[pdr.node_id];

        return newGroup && newGroup !== pdr.node_name;
      });

      if (changedNodes.length > 0) {
        await Promise.all(
          changedNodes.map((pdr) =>
            editPublishedDiagRuleNode(controller, {
              publishedDiagRuleId: publishedId,
              nodeId: pdr.node_id,
              editedData: { group_name: newGroupMap[pdr.node_id] },
            })
          )
        );
      }

      const newPdrList = await getPublishedDiagRuleNode(controller, {
        publishedDiagRuleId: publishedId,
      });

      controller.setState(prev => ({
        MeFormSequence: {
          ...prev.MeFormSequence,
          formDetailPage: {
            ...prev.MeFormSequence?.formDetailPage,
            pdrNodeList: newPdrList || [],
          },
        },
      }));
    } catch (e) {
      console.error("Error Updating PDF Nodes: ", e);
    }
  }

  setButtonLoadCheck(controller, BTN_ACTS.SAVE_FORM, BLC_STATUS.SUCCESS);

  Action(controller, {
    sequence: "MeForm",
    action: ACTIONS.FETCH,
    division: division ?? controller.data.division,
    detailData: saveFormResult,
  });
};

const HandlePublishForm: Handler<Params<Actions["PUBLISH_FORM"]>> = async (controller, params) => {
  const { formId, data, division } = params;

  setButtonLoadCheck(controller, BTN_ACTS.PUBLISH_FORM, BLC_STATUS.LOADING);

  const publishedData: PublishedDiagRuleSerializer = {
    diag_rule: formId,
    content: data.content,
  };

  const publishedResult = await publishDiagRule(controller, { publishedData });

  if (!publishedResult) {
    setButtonLoadCheck(controller, BTN_ACTS.PUBLISH_FORM, BLC_STATUS.ERROR);
    return;
  }

  const formDetailResult = await getDiagRuleDetail(controller, { formId });

  if (!formDetailResult) {
    setButtonLoadCheck(controller, BTN_ACTS.PUBLISH_FORM, BLC_STATUS.ERROR);
    return;
  }

  const pdrNodeResult = await getPublishedDiagRuleNode(controller, {
    publishedDiagRuleId: publishedResult.id,
  });

  if (!pdrNodeResult) {
    setButtonLoadCheck(controller, BTN_ACTS.PUBLISH_FORM, BLC_STATUS.ERROR);
    return;
  }

  setButtonLoadCheck(controller, BTN_ACTS.PUBLISH_FORM, BLC_STATUS.SUCCESS);

  Action(controller, {
    sequence: "MeForm",
      action: ACTIONS.FETCH,
      division: division ?? controller.data.division,
      detailData: formDetailResult as DiagRuleSerializer,
      pdrNodeData: pdrNodeResult as PublishedDiagRuleNodeSerializer[],
  });
};

const HandleEditForm: Handler<Params<Actions["EDIT_FORM"]>> = async (controller, params) => {
  // const state = controller.getState();

  const { formId, editedData, division } = params;

  setLoading(controller, DETAIL_CARD_NAME, true);
  setButtonLoadCheck(controller, BTN_ACTS.EDIT_FORM, BLC_STATUS.LOADING);

  const [editFormResult, editFormErr] = await editDiagRuleDetail(controller, {
    formId,
    editedData,
  });

  if (editFormErr || !editFormResult) {
    setLoading(controller, DETAIL_CARD_NAME, false);
    setButtonLoadCheck(controller, BTN_ACTS.EDIT_FORM, BLC_STATUS.ERROR);
    setErrorMessage(controller, MAIN_CARD_NAME, editFormErr);
    return;
  }

  setLoading(controller, DETAIL_CARD_NAME, false);
  setButtonLoadCheck(controller, BTN_ACTS.EDIT_FORM, BLC_STATUS.SUCCESS);

  if (params.onSuccess) {
    params.onSuccess();
  }

  Action(controller, {
    sequence: "MeForm",
    action: ACTIONS.FETCH,
    division: division ?? controller.data.division,
    detailData: editFormResult,
  });
};

const HandleGetBroadcastNodeList: Handler<Params<Actions["GET_BROADCAST_NODE_LIST"]>> = async (
  controller,
  params
) => {
  const { broadcastNodeParams } = params;

  const activePage = params.activePage || 1;
  const offset = (activePage - 1) * DEFAULT_BROADCAST_LIST_LIMIT;

  setLoading(controller, BROADCAST_LIST_SEGMENT_NAME, true);

  const [resp, err] = await getBroadcastPostList(controller, { broadcastNodeParams, offset });

  if (err) {
    setLoading(controller, BROADCAST_LIST_SEGMENT_NAME, false);
    setErrorMessage(controller, DETAIL_CARD_NAME, err);
    return;
  }

  setLoading(controller, BROADCAST_LIST_SEGMENT_NAME, false);

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      formDetailPage: {
        ...prev.MeFormSequence?.formDetailPage,
        broadcastNodeList: {
          activePage,
          items: resp.items || [],
          total: resp.total || 0,
        },
        postCalculateCredit: undefined,
      },
    },
  }));
};

const HandleGetPostCalculateCredit: Handler<Params<Actions["GET_POST_CALCULATE_CREDIT"]>> = async (
  controller,
  params
) => {
  const { calculateParams } = params;

  const [resp, err] = await getPostCalculatedCredit(controller, { calculateParams });

  // test firebase
  // const bcResp = await getBroadcastListFirebase(controller);

  // console.log("Yeti [bcResp]: ", bcResp);

  if (err || !resp) {
    setErrorMessage(controller, MAIN_CARD_NAME, err);
    return;
  }

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      formDetailPage: {
        ...prev.MeFormSequence?.formDetailPage,
        postCalculateCredit: resp as PostCalculateCredit,
      },
    },
  }));
};

const HandleCreatePostBroadcast: Handler<Params<Actions["POST_BROADCAST"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();

  const { createdData } = params;
  const existingData = state.MeFormSequence?.firebaseData?.selectedBroadcast;

  const btnKey = `${BTN_ACTS.POST_BROADCAST}_${createdData.status}`;

  setButtonLoadCheck(controller, btnKey, BLC_STATUS.LOADING);

  const [fbId, fbErr] = await createBroadcastFirebase(controller, { createdData, existingData });

  if (fbErr || !fbId) {
    setButtonLoadCheck(controller, btnKey, BLC_STATUS.ERROR);
    setErrorMessage(controller, MAIN_CARD_NAME, fbErr);
    return;
  }

  const data: CreatedBroadcastDataApi = {
    ...createdData,
    firebase_id: fbId,
    division: controller.data.division ?? 0
  };

  const [postBroadcastResp, postBroadcastErr] = await postBroadcast(controller, { data });

  if (postBroadcastErr || !postBroadcastResp) {
    setButtonLoadCheck(controller, btnKey, BLC_STATUS.ERROR);
    setErrorMessage(controller, MAIN_CARD_NAME, postBroadcastErr);
    return;
  }

  await GetUpdatedByUserFirebase(controller, { firebaseId: postBroadcastResp?.firebase_id });

  setButtonLoadCheck(controller, btnKey, null);

  if (createdData.status === "DRAFTED") {
    setSuccessMessage(controller, MAIN_CARD_NAME, "The Broadcast's Post has drafted");
  }

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      formDetailPage: {
        ...prev.MeFormSequence?.formDetailPage,
        broadcastDetail: postBroadcastResp,
      },
    },
  }));
};

const GetUpdatedByUserFirebase: Handler<{ firebaseId: string }> = async (controller, params) => {
  const { firebaseId } = params;

  const fbBroadcast = await getBroadcastDetailFirebase(controller, { firebaseId });

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      formDetailPage: {
        ...prev.MeFormSequence?.formDetailPage,
        updatedByUserFirebase: fbBroadcast ? fbBroadcast?.updated_by : undefined,
      },
    },
  }));
};
/*================================ CONTENT HANDLERS ==============================*/

const HandleAddContent: Handler = async (controller, params) => {
  // const broadcasts = state.MeFormSequence?.firebaseData?.broadcastList ?? [];
  // const append = [...broadcasts];

  const collectionRef = collection(controller.db as Firestore, COLLECTION);
  const docRef = doc(collectionRef);

  const documentUid = docRef.id;
  
  const init: BroadcastDataFirebase = {
    id: documentUid,
    division_id: controller.data.division,
  };

  // append.unshift(init);

  // console.log("Yeti [HandleAddContent]: ", { init, documentUid, docRef });

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      firebaseData: {
        ...prev.MeFormSequence?.firebaseData,
        selectedBroadcast: init,
        // broadcastList: append,
      },
    },
  }));
};

const HandleUpdateContent: Handler<Params<Actions["UPDATE_CONTENT"]>> = async (controller, params) => {
  let ret: any;

  if (!params.id) {
    console.warn("[HandleUpdateContent] ID doesn't exist!!");
    return undefined;
  }

  let broadcast = controller.getState().MeFormSequence?.firebaseData?.selectedBroadcast;

  if (!broadcast) {
    console.warn("[HandleUpdateContent] Broadcast Data doens't exist!!");

    return undefined;
  }

  if ("content" in params) broadcast = { ...broadcast, content: params.content };

  if ("files" in params && "info" in params && params.files?.[0]) {
    ret = await uploadFileToBroadcastFolder(controller, {
      file: params.files[0],
      bucketName: MEHEALTH_BROADCAST_GS,
      broadcastId: params.id,
      idx: params.index || 0,
    });
  }

  const media = findMediaTagsAndText(params.content || "");
  const previewText = media?.previews_text?.slice(0, 175) || "";

  broadcast = {
    ...broadcast,
    shorthen_text: previewText,
    previews_text: media?.previews_text || "",
    previews_picture: media?.previews_pictures || [],
    previews_video: media?.previews_videos || [],
  };

  controller.setState(prev => ({
    MeFormSequence: {
      ...prev.MeFormSequence,
      firebaseData: {
        ...prev.MeFormSequence?.firebaseData,
        selectedBroadcast: broadcast,
        loading: false,
      },
    },
  }));

  // console.log("[HandleUpdateContent] Ret: ", ret);

  return ret;
};

/*================================ API HANDLERS ==============================*/

const getDiagRuleList: Handler<
  { division?: number; active: boolean; offset?: number },
  Promise<DiagFormListResponse | null>
> = async (controller, params) => {
  const { division, active } = params;

  const [resp, err] = await DiagRuleList.list({
    apiToken: controller.apiToken,
    params: {
      active,
      division: division ?? controller.data?.division,
      offset: params.offset,
      limit: DEFAULT_DIAG_FORM_LIMIT,
    },
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp;
};

const createDiagRule: Handler<
  { createdData?: CreatedData; division?: number },
  Promise<[DiagRuleSerializer | null, any]>
> = async (controller, params) => {
  const data = {
    ...params.createdData,
    content: params.createdData?.content ?? INIT_NODE,
    division: params.division,
  };

  const [resp, err] = await DiagRuleList.create({
    apiToken: controller.apiToken,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const getDiagRuleDetail: Handler<{ formId?: number }, Promise<DiagRuleSerializer | null>> = async (
  controller,
  params
) => {
  if (!params.formId) {
    console.warn("[getDiagRuleDetail] Form ID doesn't exist!!!");

    return null;
  }

  const [resp, err] = await DiagRuleDetail.retrieve({
    apiToken: controller.apiToken,
    pk: params.formId,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp;
};

const saveDiagRuleDetail: Handler<
  { formId?: number; data: SaveFormData },
  Promise<DiagRuleSerializer | null>
> = async (controller, params) => {
  if (!params.formId) {
    console.warn("[saveDiagRuleDetail] Form ID doesn't exist!!");

    return null;
  }

  const data = params.data;

  const [resp, err] = await DiagRuleDetail.patch({
    apiToken: controller.apiToken,
    pk: params.formId,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp;
};

const editDiagRuleDetail: Handler<
  { formId?: number; editedData?: CreatedData },
  Promise<[DiagRuleSerializer | null, any]>
> = async (controller, params) => {
  if (!params.formId) {
    const errMsg = "Form ID doesn't exist!!";
    console.warn(`[editDiagRuleDetail] ${errMsg}`);

    return [null, errMsg];
  }

  const data = params.editedData as DiagRuleSerializer;

  const [resp, err] = await DiagRuleDetail.patch({
    apiToken: controller.apiToken,
    pk: params.formId,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const publishDiagRule: Handler<
  { publishedData?: PublishedDiagRuleSerializer },
  Promise<PublishedDiagRuleSerializer | null>
> = async (controller, params) => {
  if (!params.publishedData) {
    console.warn("[publishDiagRule] Form ID doesn't exist!!");

    return null;
  }

  const data = params.publishedData as PublishedDiagRuleSerializer;

  const [resp, err] = await PublishedDiagRuleList.create({
    apiToken: controller.apiToken,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp;
};

const getPublishedDiagRuleNode: Handler<
  { publishedDiagRuleId?: number },
  Promise<PublishedDiagRuleNodeSerializer[] | null>
> = async (controller, params) => {
  if (!params.publishedDiagRuleId) {
    console.warn("[getPublishedDiagRuleNode] Published ID doesn't exist!!");

    return null;
  }

  const [resp, err] = await PublishedDiagRuleNodeList.list({
    apiToken: controller.apiToken,
    params: {
      published_diag_rule: params.publishedDiagRuleId,
    },
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp?.items || [];
};

const editPublishedDiagRuleNode: Handler<
  { publishedDiagRuleId?: number; nodeId?: number; editedData: { group_name?: string } },
  Promise<PublishedDiagRuleNodeSerializer | null>
> = async (controller, params) => {
  if (!params.publishedDiagRuleId && !params.nodeId) {
    console.warn("[editPublishedDiagRuleNode] Published ID or Node Id doesn't exist!!");

    return;
  }

  const [resp, err] = await PublishedDiagRuleNodeFromNodeIdView.put({
    apiToken: controller.apiToken,
    pdr_id: params.publishedDiagRuleId,
    node_id: params.nodeId,
    data: params.editedData,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return null;

  return resp;
};

const getBroadcastPostList: Handler<
  { broadcastNodeParams: BroadcastNodeParams; offset?: number },
  Promise<[BroadcastPostSerializer[] | null] | any>
> = async (controller, params) => {
  if (!params.broadcastNodeParams?.published_diag_rule_node) {
    const errMsg = "Published Node ID doesn't exist!!";
    console.warn(`[getBroadcastPostList] ${errMsg}`);

    return [null, errMsg];
  }

  const [resp, err] = await BroadcastPostList.list({
    apiToken: controller.apiToken,
    params: {
      ...params.broadcastNodeParams,
      offset: params.offset,
      limit: DEFAULT_BROADCAST_LIST_LIMIT,
    },
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const postBroadcast: Handler<
  { data?: CreatedBroadcastDataApi },
  Promise<[BroadcastPostSerializer | null, any]>
> = async (controller, params) => {
  const { data } = params;

  const [resp, err] = await BroadcastPostList.create({
    apiToken: controller.apiToken,
    data,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const getPostCalculatedCredit: Handler<
  { calculateParams: PostCalculateCreditParams },
  Promise<[PostCalculateCredit | null, any]>
> = async (controller, params) => {
  if (!params.calculateParams?.published_diag_rule_nodes) {
    const errMsg = {
      published_diag_rule_nodes: ["Published Diag Rule Node ID doens't exist!!"],
    };
    console.warn(`[getPostCalculatedCredit] ${errMsg.published_diag_rule_nodes}`);

    return [null, errMsg];
  }

  const [resp, err] = await BroadcastPostCalculateCredit.get({
    apiToken: controller.apiToken,
    params: params.calculateParams,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

// todo --- Optimized or Get When Select from Dropdown Only
const getPatientByLeafNode: Handler<{
  findPatientParams: {
    published_diag_rule_id: number;
    leaf_node_id?: number;
    leaf_node_label?: string;
    diag_rule_id?: number;
  };
}, Promise<[PatientByLeafResponse | null, any]>> = async (controller, params) => {
  const { findPatientParams } = params;

  const [resp, err] = await FindPatientByLeafNode.post({
    apiToken: controller.apiToken,
    data: findPatientParams,
    extra: {
      division: controller.data.division,
    },
  });

  if (err) return [null, err];

  return [resp, null];
};

const getUserDetail: Handler<{ user?: number | null; }, Promise<EmployeeSerializer | null>> = async (controller, params) => {
  if (!params?.user) {
    console.warn("[getUserList] User doesn't exist!!");
    return null;
  }

  const [resp, err] = await UserEmployeeDetailAPIView.retrieve({
    apiToken: controller.apiToken,
    pk: params.user,
    extra: {
      division: controller.data.division,
    }
  });

  if (err) return null;

  return resp;
};

const getFormCategoryList: Handler<{ formCategoryParams?: FormCategoryParams }, Promise<FormCategorySerializer[]>> = async (controller, params) => {
  const [resp, err] = await FormCategoryList.list({
    apiToken: controller.apiToken,
    params: {
      ...(params.formCategoryParams ?? {}),
      limit: 9999,
    },
    extra: { division: controller.data.division },
  });

  if (err) return [];

  return resp.items || [];
};

const downloadDiagFormAnswer: Handler<{ formId?: number }> = async (controller, params) => {
  const [resp, err, net] = await DiagRuleDownloadDiagFormAnswerXLSXView.get({
    apiToken: controller.apiToken,
    pk: params.formId,
    extra: {
      division: controller.data.division,
      responseType: "arraybuffer"
    },
  });

  if (err || !resp) return;

  const disposition = net?.headers?.["content-disposition"];
  const rawFileName = getFilenameFromDisposition(disposition);
  const pureFileName = stripExtension(rawFileName) ?? `Raw Diag Form ${params.formId}`;

  downloadXLSX(resp, pureFileName);
};

/*================================ FIREBASE ==============================*/

const getBroadcastListFirebase: Handler = async (controller, params) => {
  const db = controller.db as Firestore;
  const querySnapshot = await getDocs(collection(db, COLLECTION));

  let broadcastList: BroadcastListType[] = [];

  querySnapshot.forEach((doc: DocumentData) => {
    broadcastList.push({ id: doc.id, data: doc.data() });
  });

  return broadcastList;
};

const getBroadcastDetailFirebase: Handler<{ firebaseId: string }> = async (controller, params) => {
  const { firebaseId } = params;
  
  const db = controller.db as Firestore;
  const ref = doc(db, COLLECTION, firebaseId);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;

  return snap.data();
};

const createBroadcastFirebase: Handler<
  { createdData: CreatedBroadcastData; existingData?: BroadcastDataFirebase },
  Promise<[string | null, any]>
> = async (controller, params) => {
  const { createdData, existingData } = params;

  // console.log("Yeti [Prep]: ", { parsed: findMediaTagsAndText(createdData.content), existingData, createdData });

  try {
    const db = controller.db as Firestore;
    const broadcastId = existingData?.id || `broadcast_${Date.now()}`;

    const newData: BroadcastDataFirebase = {
      ...existingData,
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
      status: createdData.status,
      is_active: true,
      version: 1,
      published_version: 1,
      author_id: controller.data.userProfile?.id,
      updated_by: {
        id: controller.data.userProfile?.id,
        name: controller.data.userProfile?.full_name,
      },
    };

    // console.log("Yeti [CreateBroadcast] newData: ", newData);

    const docRef = doc(db, COLLECTION, broadcastId);
    
    await setDoc(docRef, newData);

    // console.log("Yeti [CreateBroadcast] DocRef: ", docRef);

    return [broadcastId, null];
  } catch (err) {
    console.error("[createBroadcast] Firebase create error: ", err);
    return [null, err];
  };
};

/*================================ UTILS ==============================*/

const findMediaTagsAndText = (content: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");

  const images = Array.from(doc.querySelectorAll("img"));
  const videos = Array.from(doc.querySelectorAll("iframe"));
  const texts = doc.body.textContent || doc.body.innerText || "";

  const parsedContent = {
    previews_text: texts,
    previews_pictures: images.map((img) => img.src),
    previews_videos: videos.map((video) => video.src),
  };

  return parsedContent;
};

const uploadFileToBroadcastFolder = async (
  controller: any,
  params: {
    file: File;
    bucketName: `gs://${string}`;
    broadcastId: string;
    idx: number;
  }
): Promise<{
  url: string;
  name: string;
  size: number;
}> => {
  const fileName = `${params.idx}_${params.file.name}`;
  const objectPath = `images/${params.broadcastId}/${fileName}`;

  const storageRef = ref(
    controller.storage,
    `${params.bucketName}/${objectPath}`
  );

  const metadata = params.file.type
    ? { contentType: params.file.type }
    : undefined;

  const uploadTask = uploadBytesResumable(storageRef, params.file, metadata);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      () => {},
      (err) => reject(err),
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);

        resolve({
          url,
          name: params.file.name,
          size: params.file.size,
        });
      }
    );
  });
};

const getFilenameFromDisposition = (disposition?: string) => {
  if (!disposition) return undefined;

  const filenameMatch =
    disposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);

  return filenameMatch ? decodeURIComponent(filenameMatch[1]) : undefined;
};

const stripExtension = (filename?: string) => {
  if (!filename) return filename;
  return filename.replace(/\.[^/.]+$/, "");
};